import { createSelector } from "reselect";
import { getAllAccounts } from "./selectors";
import { formatMortgageAccountsForDropdown } from "./utils";
import { AccountLOB, AccountStatus, } from "../types";
import { getCustomizations } from "../../customization/selectors";
/**
 * Returns all mortgage accounts or an empty array.
 */
var getAllMortgageAccounts = createSelector(getAllAccounts, function (accounts) {
    var _a;
    return (_a = accounts === null || accounts === void 0 ? void 0 : accounts.filter(function (account) {
        return [AccountLOB.MORTGAGE].includes(account.lob);
    })) !== null && _a !== void 0 ? _a : [];
});
var getOpenMortgageAccounts = createSelector(getAllMortgageAccounts, function (accounts) {
    return accounts.filter(function (_a) {
        var status = _a.status;
        return status !== AccountStatus.PAIDOFF;
    });
});
var getMortgageAccountsForDropdown = createSelector(getAllMortgageAccounts, function (_, customizations) { return getCustomizations(customizations); }, function (accounts) {
    return formatMortgageAccountsForDropdown(accounts);
});
var hasBlockedAccounts = createSelector(getAllMortgageAccounts, function (accounts) {
    return accounts.some(function (account) { var _a; return !!((_a = account.indicator) === null || _a === void 0 ? void 0 : _a.blocked); });
});
export default {
    getAll: getAllMortgageAccounts,
    getAllForDropdown: getMortgageAccountsForDropdown,
    getOpen: getOpenMortgageAccounts,
    hasBlockedAccounts: hasBlockedAccounts,
};
//# sourceMappingURL=mortgage.js.map